import { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { toast } from "react-toastify";
import Button from "../../componentes/button/button";
import Input from "../../componentes/input/input";
import VeiculoService from "../../services/resource/veiculoService";
import * as Yup from "yup";
import InputFormat from "../../componentes/inputMask/inputMask";
import { useAuth } from "../../context/authContext";
import FilialService from "../../services/resource/filialService";
import DropDown from "../../componentes/dropdown/dropdown";

const veiculoSchema = Yup.object({
  placa: Yup.string().required("Placa obrigatória"),
  codigoSolar: Yup.string().required("Código obrigatório"),
  codigoYork: Yup.string().required("Código obrigatório"),
});


export default function VeiculoCreate({ id, onClose, onCloseEdit }) {
  const service = new VeiculoService();
  const filialService = new FilialService();

  const { user } = useAuth();

  const veiculoValuesInitial = {
    placa: "",
    codigoSolar: "",
    codigoYork: "",
    modelo: "",
    tipo: "",
    kmAtual: "",
    situacao: "",
    responsavelNome: "",
    filialId: user.filialId,
    ativo: true
  };

  const [veiculo, setVeiculo] = useState(veiculoValuesInitial)
  const [isEdit, setIsEdit] = useState(false);
  const [filiais, setFiliais] = useState([]);

  useEffect(() => {
    if (id) {
      setIsEdit(true);

      service.buscarPorId(id).then(veiculo => {
        setVeiculo(veiculo.data);
      });
    }

    filialService.listar().then(res => setFiliais(res.data))

    setVeiculo(prev => ({ ...prev, filialId: user.filialId }))
  }, [id]);

  function salvar(values, { setSubmitting }) {
    service.salvar(values)
      .then((res) => {
        toast.success("Veículo cadastrado com sucesso!");
        onCloseEdit?.(res.data);
      })
      .catch(() => console.error("Erro ao salvar veículo"))
      .finally(() => setSubmitting(false));
  }

  function atualizar(values, { setSubmitting }) {
    service.atualizar(values.id, values)
      .then((res) => {
        toast.success("Veículo atualizado com sucesso!");
        onCloseEdit?.(res.data);
      })
      .catch(() => toast.error("Erro ao salvar veículo"))
      .finally(() => setSubmitting(false));
  }

  return (
    <div
      icon="fa fa-truck"
      title={isEdit ? 'Atualizar Veículo' : 'Cadastro de Veículo'}
    >

      <Formik
        enableReinitialize={isEdit ? true : false}
        initialValues={veiculo}
        validationSchema={veiculoSchema}
        onSubmit={isEdit ? atualizar : salvar}
      >

        {({ values, errors, touched, setFieldValue, setFieldTouched, isSubmitting }) => (
          <>
            <Form className="">
              <div className="grid grid-cols-1 md:grid-cols-8 gap-4 p-4">
                <div className="col-span-2">
                  <DropDown
                    label="Filial"
                    required
                    value={values.filialId}
                    options={filiais}
                    optionLabel="nome"
                    optionValue="id"
                    onChange={e => setFieldValue("filialId", e.target.value)}
                    onBlur={() => setFieldTouched("filialId", true)}
                    error={errors.filialId}
                    touched={touched.filialId}
                  />
                </div>

                <InputFormat
                  label="Placa"
                  required
                  value={values.placa}
                  onChange={value => setFieldValue("placa", value)}
                  onBlur={() => setFieldTouched("placa", true)}
                  error={errors.placa}
                  touched={touched.placa}
                  helpText="Formato padrão: ABC-1234"
                  mask='aaa-9*99'
                />

                <Input
                  label="Código York"
                  required
                  value={values.codigoYork}
                  onChange={e => setFieldValue("codigoYork", e.target.value)}
                  onBlur={() => setFieldTouched("codigoYork", true)}
                  error={errors.codigoYork}
                  touched={touched.codigoYork}
                />

                <Input
                  label="Código Solar"
                  required
                  value={values.codigoSolar}
                  onChange={e => setFieldValue("codigoSolar", e.target.value)}
                  onBlur={() => setFieldTouched("codigoSolar", true)}
                  error={errors.codigoSolar}
                  touched={touched.codigoSolar}
                />

                <Input
                  label="Modelo"
                  value={values.modelo}
                  onChange={e => setFieldValue("modelo", e.target.value)}
                />

                <Input
                  label="Tipo"
                  value={values.tipo}
                  onChange={e => setFieldValue("tipo", e.target.value)}
                />

                <Input
                  type="number"
                  label="KM Atual"
                  value={values.kmAtual}
                  onChange={e => setFieldValue("kmAtual", e.target.value)}
                />

                <Input
                  label="Situação"
                  value={values.situacao}
                  onChange={e => setFieldValue("situacao", e.target.value)}
                />

                <Input
                  label="Responsável"
                  value={values.responsavelNome}
                  onChange={e => setFieldValue("responsavelNome", e.target.value)}
                />
              </div>
              <div className="col-span-full flex justify-end gap-2 pt-4 border-top p-4">
                <Button
                  type="button"
                  label="Voltar"
                  iconLeft="fa fa-arrow-left"
                  variant="gray"
                  onClick={() => onClose?.()}
                />
                <Button
                  type="submit"
                  label={isEdit ? "Confirmar Alterações" : "Cadastrar Veículo"}
                  loading={isSubmitting}
                  iconLeft="fa fa-save"
                />
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}